export default __webpack_public_path__ + "static/media/award4.4e75875b.jpg";